import React, { useEffect } from 'react';
import bgImg from '../../../assets/img/advent-background-bow.jpg';
import Brand from './Brand';
import Topbar from './Topbar';
import Menu from './Menu';

function Header() {

	useEffect(() => {    
		console.log('header');	
	
	}, []);

	const backgroundOverlayStyle = {
		background: "linear-gradient(rgb(0 0 0 / 100%), rgb(0 0 0 / 15%))"
	}
	const backgroundOverlayStyleBottom = {
		background: "linear-gradient(rgb(0 0 0 / 15%), rgb(0 0 0 / 0%))"
	}
	
  return (
    <div id="kt_header" className="kt-header kt-grid__item kt-header--fixed " data-ktheader-minimize="on" style={{backgroundImage: "url(" + bgImg + ")", backgroundPosition: "bottom"}}>
		<div className="kt-header__top" style={backgroundOverlayStyle}>
			<div className="kt-container ">

				<Brand></Brand>

				<Topbar></Topbar>
			</div>
		</div>
		<div className="kt-header__bottom" style={backgroundOverlayStyleBottom}>
			<div className="kt-container ">

				<Menu></Menu>
			</div>
		</div>
	</div>

  );
}

export default Header;